/**
 * Global Disclaimers
 * @file disclaimers.js
 */

let gdsups = [];

function updateDisclaimerIcons() {
  const dataAttr = 'data-gd';
  const disclaimers = document.querySelectorAll('.page-disclaimers [' + dataAttr + ']');
  gdsups = [];

  // loop through disclaimers and store the sup
  disclaimers.forEach(function(disclaimer) {
    const gd = disclaimer.getAttribute(dataAttr);
    const sup = disclaimer.querySelector('sup');
    // validate that the sup found is the first character in the disclaimer
    // and not something like a registered trademark or similar found later
    if (sup && disclaimer.textContent.charAt(0) == sup.textContent.charAt(0)) {
      gdsups[gd] = sup;
    }
  });

  updateDisclaimerIconsInElement(document);
}

function updateDisclaimerIconsInElement(element) {
  const icons = element.querySelectorAll('.gd-icon');
  if  (!icons || icons.length === 0) {
    return;
  }

  // loop through icons and update the sup
  icons.forEach(function(icon) {
    updateDisclaimerIconText(icon);
  });
}

function updateDisclaimerIconText(icon) {
  const gd = icon.textContent;
  const sup = gdsups[gd];
  // replace the placeholder
  if (sup) {
    // check if the value needs the <sup> tag
    const char = sup.textContent;
    icon.outerHTML = (/[0-9~^*†]/.test( char )) ? sup.outerHTML : char;
  } else {
    icon.remove();
  }
}

function updateDisclaimerIconInText(text) {
  // create new element to parse the HTML
  const element = document.createElement('div');
  element.innerHTML = text;

  // append to body so that we can modify it
  const body = document.querySelector('body');
  body.appendChild(element);

  // update the element
  updateDisclaimerIconsInElement(element);

  // remove the element
  body.removeChild(element);

  // return the html
  return element.innerHTML;
}